class HeaderScrollHandler {
  constructor() {
    this.header = document.querySelector('.header__container');

    if (!this.header) return;

    this.lastScrollTop = 0;
    this.ticking = false;

    this.onScroll = this.onScroll.bind(this);
    this.update = this.update.bind(this);

    window.addEventListener('scroll', this.onScroll, {
      passive: true,
    });

    this.update();
  }

  update() {
    // Skip while a drawer/overlay is open: body-controller locks scroll via
    // `position: fixed` on <body>, which collapses window.pageYOffset to 0
    // and would otherwise be misread here as "scrolled to the top", forcing
    // the header to reveal itself even though the user didn't scroll.
    if (document.body.classList.contains('overflow-hidden')) {
      this.ticking = false;
      return;
    }

    const scrollTop =
      window.pageYOffset || document.documentElement.scrollTop;

    this.header.classList.toggle('header__scrolled', scrollTop > 0);

    if (scrollTop <= this.header.offsetHeight) {
      // Near the top of the page — always show.
      this.header.classList.remove('header__hide');
    } else if (scrollTop > this.lastScrollTop) {
      // Scrolling down — hide.
      this.header.classList.add('header__hide');
    } else {
      // Scrolling up — reveal.
      this.header.classList.remove('header__hide');
    }

    this.lastScrollTop = Math.max(scrollTop, 0);
    this.ticking = false;
  }

  onScroll() {
    if (!this.ticking) {
      window.requestAnimationFrame(this.update);
      this.ticking = true;
    }
  }

  destroy() {
    window.removeEventListener('scroll', this.onScroll);
  }
}

new HeaderScrollHandler();